export const en: Record<string, string> = {
  app_title: 'How Long to Clear',
  app_subtitle: 'Find your next wishlisted game to play based on your time and budget.',
  steam_id_placeholder: 'Enter your Steam64 ID (e.g. 76561198012345678)',
  fetch_wishlist: 'Fetch Wishlist',
  landing_help: 'Your Steam profile & wishlist must be <strong>public</strong>. Find your Steam64 ID at <a href="https://steamid.io" target="_blank" rel="noopener">steamid.io</a>.',
  landing_disclaimer: 'This is a fan-made project, not affiliated with <a href="https://store.steampowered.com" target="_blank" rel="noopener">Valve</a>, <a href="https://www.gog.com" target="_blank" rel="noopener">GOG</a> or <a href="https://howlongtobeat.com" target="_blank" rel="noopener">HowLongToBeat</a>. Wishlist data is only stored locally in your browser. Source code <a href="https://github.com/t0mg/howlong">on GitHub</a>.',

  loading_games_enriched: '{count} / {total} games processed ({percent}%)',
  loading_throttled_title: 'Steam is throttling requests',
  loading_waiting: 'Waiting {time}...',
  loading_stop: 'Stop & Show Results',
  loading_stopping: 'Stopping and preparing results...',
  loading_fetching_appid: 'Fetching wishlist AppID list...',
  loading_fetching_prices: 'Fetching game prices...',
  loading_fetching_details: 'Fetching game details...',
  loading_fetching_details_count: 'Fetching details for {count} games...',
  loading_enriching: 'Enriching with HowLongToBeat data...',
  loading_enriching_gog: 'Enriching with GOG data...',

  error_wishlist_private: 'Wishlist is empty or private.',
  error_no_details: 'Could not fetch details for any games in your wishlist.',
  error_unexpected: 'An unexpected error occurred.',

  error_try_again: 'Try Again',

  dashboard_change_id: '← Change Steam ID',
  dashboard_lucky: 'I\'m Feeling Lucky',
  dashboard_insights: 'Insights',
  dashboard_filter_label: 'Filter:',
  dashboard_filter_all: 'All Categories',
  dashboard_filter_hidden: 'Hidden Games',
  dashboard_sort_label: 'Sort by:',
  dashboard_match_info: 'HLTB data found for {found} / {total} games',
  dashboard_hltb_warning: '⚠️ Some HLTB data could not be fetched due to server errors. Reload the page to try again.',

  lucky_title: 'I\'m Feeling Lucky',
  lucky_desc: 'Not sure what to play? Let fate decide.',
  lucky_too_long: 'Shorter',
  lucky_not_in_mood: 'Different',
  lucky_too_expensive: 'Cheaper',
  lucky_ok: 'Close',
  lucky_empty: 'Sorry, no more games to suggest!',

  stats_games: 'Games',
  stats_main: 'Main Story',
  stats_main_extra: 'Main + Extras',
  stats_completionist: 'Completionist',
  stats_value: 'Wishlist Value',
  stats_savings: 'Sale Savings',

  sort_priority: 'Priority',
  sort_dateAdded: 'Date Added',
  sort_name: 'Name',
  sort_hltbMain: 'Duration (Main)',
  sort_hltbMainExtra: 'Duration (Main+)',
  sort_hltbCompletionist: 'Duration (100%)',
  sort_priceFinal: 'Price',
  sort_discountPercent: 'Discount',

  settings_title: 'Settings',
  settings_desc: 'Manage your application preferences and local data.',
  settings_region_label: 'Steam Store Region',
  settings_region_desc: 'Select region for accurate local prices.',
  settings_lang_label: 'Language',
  settings_lang_desc: 'Select your preferred language.',
  settings_clear_hltb_label: 'Clear HLTB Data',
  settings_clear_hltb_desc: 'Remove stored game durations and re-fetch.',
  settings_clear_hltb_btn: 'Clear HLTB',
  settings_cleared: 'Cleared!',
  settings_clear_steam_label: 'Clear Steam Game Data',
  settings_clear_steam_desc: 'Remove cached metadata and re-fetch. Prices are fetched live.',
  settings_clear_steam_btn: 'Clear Steam',
  settings_clear_gog_label: 'Clear GOG Data',
  settings_clear_gog_desc: 'Remove cached GOG metadata and re-fetch.',
  settings_clear_gog_btn: 'Clear GOG',
  settings_clear_hidden_label: 'Clear Hidden Games',
  settings_clear_hidden_desc: 'Unhide all games that were previously hidden.',
  settings_clear_hidden_btn: 'Clear Hidden',
  settings_hard_reset_label: 'App Cache (Hard Reset)',
  settings_hard_reset_desc: 'Unregister Service Worker and clear all internal databases. App will reload.',
  settings_hard_reset_btn: 'Full Reset',
  settings_hard_reset_confirm: 'Are you sure? This will wipe ALL cached data and settings.',
  settings_close: 'Close',

  insights_title: 'Wishlist Insights',
  insights_desc: 'A data-driven breakdown of your wishlist.',
  insights_avg_price_hr: 'Avg. Price/Hr',
  insights_oldest_entry: 'Oldest Entry',
  insights_top_genre: 'Top Genre',
  insights_total_story: 'Total Story',
  insights_chart_duration: 'Duration Distribution (Hrs)',
  insights_chart_price: 'Price Distribution ({currency})',
  insights_chart_genre: 'Popular Genres',
  insights_chart_year: 'Wishlist Entry Timeline',
  insights_chart_store: 'Best Price: Steam vs GOG',

  game_coming_soon: 'Coming Soon',
  game_demo: 'Demo',
  game_demo_avail: 'Demo Avail.',
  game_added: 'Added {date}',
  game_free: 'Free',
  game_unavailable: 'Unavailable',
  game_cached: '(cached)',
  game_price_na: 'Price N/A',
  game_no_hltb: 'No HLTB data',
  game_hltb_pending: 'Looking up...',
  game_link_steam: 'Steam',
  game_link_hltb: 'HLTB',
  game_link_gog: 'GOG',
  game_link_hide: 'Hide',
  game_link_unhide: 'Unhide',

  hide_confirm_title: 'Hide Game',
  hide_confirm_desc: 'Are you sure you want to hide this game? It will be removed from your lists but will still be tracked.',
  hide_confirm_btn: 'Hide',
  hide_cancel_btn: 'Cancel',
};
